export enum BRAND {
  ESPP = 'ESPP',
  CNH = 'CNH',
  CNH_AU = 'CNH_AU',
  BOMAG = 'BOMAG',
  DYNAPAC = 'DYNAPAC',
  LIEBHERR = 'LIEBHERR',
  WACKERNEUSON = 'WACKERNEUSON',
  PROTECTION_POINT = 'PROTECTION_POINT',
}
export const DOMAIN_BRAND = {
  // DEVELOPMENT DOMAINS
  'localhost': BRAND.ESPP,
  'dev-espp.epgins.com': BRAND.ESPP,
  'espp-dev.epgins.com': BRAND.ESPP,
  'dev-ppp.epgins.com': BRAND.CNH,
  'dev-ppsp.epgins.com': BRAND.ESPP,
  'dev-bomag.epgins.com': BRAND.BOMAG,
  'dev-dynapac.epgins.com': BRAND.DYNAPAC,
  'dev-liebherr.epgins.com': BRAND.LIEBHERR,
  'dev-wackerneuson.epgins.com': BRAND.WACKERNEUSON,

  // MODEL DOMAINS
  'model-espp.assurant.com': BRAND.ESPP,
  'espp-model.epgins.com': BRAND.ESPP,
  'espp-integration-model.epgins.com': BRAND.CNH,
  'model-espp-cnh.assurant.com': BRAND.CNH,
  'model-espp-cnhau.assurant.com': BRAND.CNH_AU,
  'model-espp-protectionpoint.assurant.com': BRAND.PROTECTION_POINT,
  'model-espp-admin.assurant.com': BRAND.ESPP,
  'model-espp-bomag.assurant.com': BRAND.BOMAG,
  'model-espp-dynapac.assurant.com': BRAND.DYNAPAC,
  'model-espp-liebherr.assurant.com': BRAND.LIEBHERR,
  'model-espp-wackerneuson.assurant.com': BRAND.WACKERNEUSON,

  // QA DOMAINS
  'qa-espp.assurant.com': BRAND.ESPP,
  'espp-qa.epgins.com': BRAND.ESPP,
  'espp-integration-qa.epgins.com': BRAND.CNH,
  'qa-espp-protectionpoint.assurant.com': BRAND.PROTECTION_POINT,
  'qa-espp-cnh.assurant.com': BRAND.CNH,
  'qa-espp-bomag.assurant.com': BRAND.BOMAG,
  'qa-espp-cnhau.assurant.com': BRAND.CNH_AU,
  'qa-espp-liebherr.assurant.com': BRAND.LIEBHERR,
  'qa-espp-dynapac.assurant.com': BRAND.DYNAPAC,
  'qa-espp-wackerneuson.assurant.com': BRAND.WACKERNEUSON,

  // PRODUCTION DOMAINS
  'espp.epgins.com': BRAND.ESPP,
  'ppp.cnhinsurance.com': BRAND.CNH,
  'espp-cnh.assurant.com': BRAND.CNH,
  'espp-cnhau.assurant.com': BRAND.CNH_AU,
  'espp-protectionpoint.assurant.com': BRAND.PROTECTION_POINT,
  'espp-bomag.assurant.com': BRAND.BOMAG,
  'espp-dynapac.assurant.com': BRAND.DYNAPAC,
  'espp-liebherr.assurant.com': BRAND.LIEBHERR,
  'espp-wackerneuson.assurant.com': BRAND.WACKERNEUSON,
  'protectionpointportal.com': BRAND.PROTECTION_POINT,
  'www.protectionpointportal.com': BRAND.PROTECTION_POINT,
  'bomagespp.com': BRAND.BOMAG,
  'www.bomagespp.com': BRAND.BOMAG,
  'dynapacespp.com': BRAND.DYNAPAC,
  'www.dynapacespp.com': BRAND.DYNAPAC,

  // CEPS DOMAINS
  'ceps-espp.assurant.com': BRAND.ESPP,
  'ceps-espp-cnh.assurant.com': BRAND.CNH,
  'ceps-espp-cnhau.assurant.com': BRAND.CNH_AU,
  'ceps-espp-bomag.assurant.com': BRAND.BOMAG,
  'ceps-espp-dynapac.assurant.com': BRAND.DYNAPAC,
  'ceps-espp-liebherr.assurant.com': BRAND.LIEBHERR,
  'ceps-espp-protectionpoint.assurant.com': BRAND.PROTECTION_POINT,
  'ceps-espp-wackerneuson.assurant.com': BRAND.WACKERNEUSON,
};
